import { Surface } from '@repo/rpc-types-creativefabrica-common-v1/surface/v1'

export const marketplaceBackgroundRemoverListRequest = {
  pagination: { take: 20 },
  surface: Surface.MARKETPLACE,
}
